var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { getKeycloakInstance } from './internals/keycloak';
import { KeycloakProvider } from './internals/KeycloakProvider';
var SSRKeycloakProvider = /** @class */ (function (_super) {
    __extends(SSRKeycloakProvider, _super);
    function SSRKeycloakProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.onEvent = function (event, error) {
            var _a, _b, _c, _d;
            if (event === 'onReady') {
                if (!_this.state.keycloak.authenticated) {
                    (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.persistor) === null || _b === void 0 ? void 0 : _b.resetTokens();
                }
            }
            // Propagate events up
            (_d = (_c = _this.props) === null || _c === void 0 ? void 0 : _c.onEvent) === null || _d === void 0 ? void 0 : _d.call(_c, event, error);
        };
        _this.onTokens = function (tokens) {
            var _a, _b, _c, _d;
            // Persist updated tokens
            (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.persistor) === null || _b === void 0 ? void 0 : _b.setTokens(tokens);
            // Propagate events up
            (_d = (_c = _this.props) === null || _c === void 0 ? void 0 : _c.onTokens) === null || _d === void 0 ? void 0 : _d.call(_c, tokens);
        };
        var initOptions = props.initOptions, keycloakConfig = props.keycloakConfig, persistor = props.persistor;
        var cachedTokens = persistor.getTokens();
        _this.state = {
            keycloak: getKeycloakInstance(keycloakConfig, persistor),
            initOptions: __assign(__assign({}, cachedTokens), initOptions),
        };
        return _this;
    }
    SSRKeycloakProvider.prototype.render = function () {
        var _a = this.props, children = _a.children, persistor = _a.persistor, providerProps = __rest(_a, ["children", "persistor"]);
        var _b = this.state, initOptions = _b.initOptions, keycloak = _b.keycloak;
        return (React.createElement(KeycloakProvider, __assign({}, providerProps, { authClient: keycloak, initOptions: initOptions, onEvent: this.onEvent, onTokens: this.onTokens }), children));
    };
    return SSRKeycloakProvider;
}(React.PureComponent));
export { SSRKeycloakProvider };
//# sourceMappingURL=SSRKeycloakProvider.js.map